import React from 'react';

interface IMyProps {
  value: any;
}

export const PrintComponent = React.forwardRef((props: IMyProps, ref: any) => {
  return <div ref={ref}>{props.value}</div>;
});
export default PrintComponent;
